import {VideoConsultation} from "../../../models/VideoConsultation";
import {
  CLOSE_VIDEO_CONSULTATION_SESSION,
  PREPARE_VIDEO_CONSULTATION_SESSION,
  START_VIDEO_CONSULTATION_SESSION
} from "../constants/VideoConsultationSession";

interface VideoConsultationSessionState {
  preJoin: boolean;
  accessToken?: string;
  sharedKey?: string;
  isGuest: boolean;
  videoConsultation?: VideoConsultation;
  livekitUrl?: string;
}

const initialState: VideoConsultationSessionState = {
  preJoin: false,
  isGuest: true,
  videoConsultation: null,
  accessToken: null,
  sharedKey: null,
  livekitUrl: null
};

export function videoConsultationSession(state = initialState, action) {
  switch (action.type) {
    case PREPARE_VIDEO_CONSULTATION_SESSION:
      return Object.assign({}, state, {
        preJoin: action.preJoin,
        videoConsultation: action.videoConsultation,
        accessToken: action.accessToken,
        sharedKey: action.sharedKey,
        isGuest: action.isGuest,
        livekitUrl: action.livekitUrl
      });
    case START_VIDEO_CONSULTATION_SESSION:
      return Object.assign({}, state, {
        preJoin: false,
        videoConsultationSession: action.videoConsultation,
        accessToken: action.accessToken
      });
    case CLOSE_VIDEO_CONSULTATION_SESSION:
      return initialState;
    default:
      return state;
  }
}
